import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
import BootstrapButton from 'react-bootstrap/Button';
import classNames from 'classnames';

export default function Button(props) {
  const {icon, loading, children, disabled, className, ...rest} = props;

  function renderIcon() {
    return icon ? <Icon icon={icon} /> : '';
  }

  function renderText() {
    return children !== undefined ? <span>{children}</span> : '';
  }

  return (
    <BootstrapButton
      className={classNames(loading && 'btn-loading', className)}
      disabled={loading || disabled}
      {...rest}
    >
      {renderIcon()}
      {renderText()}
    </BootstrapButton>
  );
}

Button.defaultProps = {
  type: 'button',
  variant: 'default',
  loading: false,
};

Button.propTypes = {
  /** The FontAwesome name of an icon to add to the left of the button text. */
  icon: PropTypes.string,
  /** When true, disables the button and displays a loading icon. */
  loading: PropTypes.bool,
  /** When true, disables the button. */
  disabled: PropTypes.bool,
  /** The contents of the button. Typically an <I18n />. */
  children: PropTypes.node,
  /** An optional class name to add to the button. */
  className: PropTypes.string,
};
